<div
    class="section-padding-vertical-md lg:section-padding-vertical-lg w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
    <div class="card">
        <div class="flex flex-col gap-4">
            <p class="font-normal text-dark">Mehr Neukunden</p>

            <p>
                Durch eine optimierte Website hebst du dich automatisch von deiner Konkurrenz ab und
                bist somit immer die erste Wahl.
            </p>
        </div>
    </div>

    <div class="card">
        <div class="flex flex-col gap-4">
            <p class="font-normal text-dark">Alles aus einer Hand</p>

            <p>
                Dank unserer jahrelangen Erfahrung musst du dich um nichts kümmern. Unser Team
                kümmert sich um jeden Schritt für deinen Erfolg. Von der Analyse bis zur Wartung
                deines digitalen Verkäufers.
            </p>
        </div>
    </div>

    <div class="card">
        <div class="flex flex-col gap-4">
            <p class="font-normal text-dark">Verkaufsoptimiert</p>

            <p>
                Wir achten darauf, dass deine Zielgruppe sich verstanden fühlt. Wir erstellen nicht
                nur eine Website die gut aussieht, sondern auch verkauft.
            </p>
        </div>
    </div>

    <div class="card colored">
        <div class="flex flex-col gap-4 justify-center items-center h-full">
            <p class="font-normal text-xl">
                Wir etablieren Marktführer. Mehr als 50 Unternehmen vertrauen auf unsere
                Dienstleistungen!
            </p>
        </div>
    </div>
</div>
